import React, { FunctionComponent } from 'react';

import PaletteProvider from '@gojob/ui-bits/styles/PaletteProvider';
import Info from '../../Article/Info';

export type ArticleInfoProps = {
  node?: {
    text?: any;
  };
};

const ArticleInfo: FunctionComponent<ArticleInfoProps> = (props) => {
  if (!props.node?.text) {
    return null;
  }
  return (
    <PaletteProvider variant="primary">
      <Info>{props.node?.text}</Info>
    </PaletteProvider>
  );
};

const articleInfoRenderer = (props: ArticleInfoProps) => {
  return <ArticleInfo {...props} />;
};

export default articleInfoRenderer;
